import cn from 'classnames';
import type React from 'react';
import { forwardRef } from 'react';
import * as st from './styles.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  fullWidth?: boolean;
  label?: string;
  isValid?: boolean;
  disabled?: boolean | undefined;
}

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ fullWidth, label, isValid, disabled, className, ...props }, ref) => {
    return (
      <div className={cn(st.wrapper, className)}>
        <input
          disabled={disabled && disabled}
          ref={ref}
          className={cn(st.input, isValid && st.input__error, fullWidth && st.fullWidth)}
          {...props}
        />
        {label && <label htmlFor={props.id}>{label}</label>}
      </div>
    );
  }
);
